import { FunctionComponent } from 'react';
import classnames from 'classnames';

import StyledComponent from './styles';
import { Props, VideoType } from './types';

const LayoutVideo: FunctionComponent<Props> = ({ containerProps, videoProps, rounded }) => {
    return ((
        <StyledComponent
            {...containerProps}
            className={classnames(
                'layout-video',
                { rounded }
            )}

        >
            {videoProps.type === VideoType.Video ? (
                <video
                    className="video"
                    controls
                    width="100%"
                >
                    <source
                        src={videoProps.src}
                        type="video/mp4"
                    />
                </video>
            ) : (
                <iframe
                    frameBorder="0"
                    allowFullScreen={true}
                    src={videoProps?.src}
                />
            )}
        </StyledComponent>
    ));
};

export default LayoutVideo;